import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionsCellRendererParams } from '../../../../../../core/models/grid/actions-cell-renderer-params';
import { RouterModule } from '@angular/router';
import { ActionsCellRendererValue } from '../../../../../../core/models/grid/actions-cell-renderer-value';

@Component({
    selector: 'app-actions-cell-renderer',
    imports: [RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './actions-cell-renderer.component.html',
})
export class ActionsCellRendererComponent implements ICellRendererAngularComp {
    value: ActionsCellRendererValue = {} as ActionsCellRendererValue;
    params: ActionsCellRendererParams = {} as ActionsCellRendererParams;
    text: string = '';
    link: string = '';

    agInit(params: ICellRendererParams & ActionsCellRendererParams): void {
        this.value = params.value as ActionsCellRendererValue;
        this.params = params as ActionsCellRendererParams;
        this.text = this.getText();
        this.link = this.getLink();
    }

    refresh(): boolean {
        return false;
    }

    getLink(): string {
        if (this.params.editParams && this.value.edit) {
            return this.params.editParams.path.replace(
                ':id',
                this.value.edit?.id.toString() || '',
            );
        } else if (this.params.viewParams && this.value.view) {
            return this.params.viewParams.path;
        } else if (this.params.reviewParams && this.value.review) {
            return this.params.reviewParams.path.replace(
                ':id',
                this.value.review?.id.toString() || '',
            );
        }

        return '';
    }

    getText(): string {
        if (this.params.editParams && this.value.edit) {
            return 'Edit';
        } else if (this.params.viewParams && this.value.view) {
            return 'View';
        } else if (this.params.reviewParams && this.value.review) {
            return 'Review';
        }

        return '';
    }
}
